import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import DevicesServiceBoxPopUp from '../DevicesAndEquipmentsBlock/DevicesServiceBoxPopUp';
import PopUp from '../../Shared/Popup/PopUp';
import BtnWhiteBlackBorderBigSize from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { isMobile } from 'react-device-detect';
import { setIsWorkOrderSucceeded } from '../WelcomeBlock/welcomeBlockSlice';
import UpgradeCellularDeviceSwiperDesktop from './UpgradeCellularDeviceSwiperDesktop';
import UpgradeCellularDeviceSwiperMobile from './UpgradeCellularDeviceSwiperMobile';
import ErrorPage from '../../Shared/ErrorPage/ErrorBlock';
import { createReportUpgradeCellular } from '../../../utilities/reports/createReport';

const upgradeCellularDeviceMainComponent = (props) => {
  const mainTitle = props.iContent?.mainTitle?.value;
  const secondTitle = props.iContent?.secondTitle?.value;
  const jobCodeCellularDevices = props?.iContent?.jobCodeCellularDevices?.value;
  const JobTeamCellularDevices = props?.iContent?.jobTeamCellularDevices?.value;
  const ButtonUpgradeCellularDeviceTitle = props?.iContent?.buttonUpgradeCellularDeviceTitle?.value;
  const ButtonUpgradeCellularDeviceLink = props?.iContent?.buttonUpgradeCellularDeviceLink?.value;
  const DevicesToUpgradeList = props?.iContent?.devicesToUpgradeList?.expandedValue;
  const [showPopUp, setShowPopUp] = useState(false);
  const [itemInfo, setItemInfo] = useState({});

  useEffect(() => {
    createReportUpgradeCellular();
  }, [])

  const upgradeCellularDeviceObj = {
    linkDetailsString: 'מידע נוסף',
    buttonLink: ButtonUpgradeCellularDeviceLink,
    buttonLinkTitle: ButtonUpgradeCellularDeviceTitle,
    JobCodeCellularDevices: jobCodeCellularDevices,
    JobTeamCellularDevices: JobTeamCellularDevices,
    items: DevicesToUpgradeList,
  };

  const closePopUp = () => {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    setShowPopUp(false);
  };

  return (
    <div className='upgrade-cellular-devices-main-container'>
      {upgradeCellularDeviceObj?.items ?
        <>
          <div className='titles-container'>
            <label className='main-title'>{mainTitle}</label>
            <label className='second-title'>{secondTitle}</label>
            {!isMobile ?
              <UpgradeCellularDeviceSwiperDesktop
                context={props.context}
                upgradeCellularDeviceObj={upgradeCellularDeviceObj}
                setIsWorkOrderSucceeded={() => props.setIsWorkOrderSucceeded('')}
                setShowPopUp={(bool) => setShowPopUp(bool)}
                setItemInfo={(item) => setItemInfo(item)}
              /> :
              <UpgradeCellularDeviceSwiperMobile
                context={props.context}
                upgradeCellularDeviceObj={upgradeCellularDeviceObj}
                setIsWorkOrderSucceeded={() => props.setIsWorkOrderSucceeded('')}
                setShowPopUp={(bool) => setShowPopUp(bool)}
                setItemInfo={(item) => setItemInfo(item)}
              />}
          </div>
          <div className='footer-bottom-container'>
            {upgradeCellularDeviceObj?.buttonLinkTitle !== '' && upgradeCellularDeviceObj?.buttonLinkTitle != null && (
              <BtnWhiteBlackBorderBigSize
                className='offers'
                onclick={() => props.context.navigateTo(upgradeCellularDeviceObj?.buttonLink)}
                text={upgradeCellularDeviceObj?.buttonLinkTitle}
              />
            )}
          </div>
        </> :
        <ErrorPage subTitle={'לא מצאנו מוצרים סלולרים לשדרוג'} buttonTitle={upgradeCellularDeviceObj.buttonLinkTitle} buttonLink={upgradeCellularDeviceObj?.buttonLink} />
      }
      {showPopUp && (
        <PopUp showPopUp={showPopUp} onClose={() => closePopUp()}>
          <DevicesServiceBoxPopUp
            isPopUp={true}
            showPopup={setShowPopUp}
            workOrderCodeInput={jobCodeCellularDevices}
            workOrderTeamInput={JobTeamCellularDevices}
            productPriceInput={itemInfo?.price.value}
            productInfoInput={itemInfo?.description.value}
            footerButton={<BtnSubmit onclick={() => setShowPopUp(false)} text='סגור' />}
          />
        </PopUp>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  setIsWorkOrderSucceeded,
};

export default connect(null, mapDispatchToProps)(upgradeCellularDeviceMainComponent);
